// Mutations enums
export enum MutationTypes {
  SET_BALLOT_QUESTIONS = "SET_BALLOT_QUESTIONS",
}
